import {
  EmptyState as EmptyStateBase,
  EmptyStateImageVariant,
  EmptyStateVariant,
} from '../../../../../components/empty-state/index';
import { useLocale } from '../../../../../hooks/index';

export const SignaturesEmptyState = () => {
  const { messagesLocale } = useLocale();

  return (
    <EmptyStateBase
      colorScheme={EmptyStateVariant.ORANGE}
      description={messagesLocale['SIGNATURES_EMPTY_DESCRIPTION']}
      imageVariant={EmptyStateImageVariant.CLIPBOARD}
      text={messagesLocale['SIGNATURES_EMPTY_TITLE']}
    />
  );
};
